const loadItems = (() => {
  let isLoading = false;

  return (button) => {
    if (isLoading) return;
    isLoading = true;

    const totalPages = parseInt($("[data-total-pages]").val());
    let currentPage = parseInt($("[data-current-page]").val());
    currentPage = currentPage + 1;

    const rawValueEl = document.querySelector("[data-next-url]");
    const rawValue = rawValueEl ? rawValueEl.value : null;

    const getUrlWithoutPhcursor = (value, pageValue) => {
      const url = new URL(value, window.location.origin);
      url.searchParams.set("page", pageValue);
      url.searchParams.delete("phcursor");
      return url.pathname + "?" + url.searchParams.toString();
    };

    if (!rawValue) {
      isLoading = false;
      return;
    }

    const nextUrl = getUrlWithoutPhcursor(rawValue, currentPage);

    button.setAttribute("disabled", "");
    button.classList.add("loading");
    $("[data-current-page]").val(currentPage);

    $.ajax({
      url: nextUrl,
      type: "GET",
      dataType: "html",
      success: function (responseHTML) {
        $(".load-more-grid").append($(responseHTML).find(".load-more-grid").html());
        if (typeof colorSwatches === "function") colorSwatches();
        if (typeof window.updateShowingText === "function") window.updateShowingText();
      },
      complete: function () {
        if (currentPage <= totalPages) {
          const scollData = document.querySelector(".infinite-scroll__data");

          if (scollData && currentPage !== totalPages) {
            const currentNext = $("[data-next-url]").val();

            // Build next page URL robustly (avoids replace() failures on iOS)
            const urlObj = new URL(currentNext, window.location.origin);
            urlObj.searchParams.set("page", String(currentPage + 1));
            urlObj.searchParams.delete("phcursor");
            const nextUrlScroll = urlObj.pathname + "?" + urlObj.searchParams.toString();

            const nextInput = scollData.querySelector("input[data-next-url]");
            const currentInput = scollData.querySelector("input[data-current-page]");

            if (nextInput) {
              nextInput.dataset.nextUrl = nextUrlScroll;
              nextInput.value = nextUrlScroll;
            }
            if (currentInput) {
              currentInput.dataset.currentPage = String(currentPage);
              currentInput.value = String(currentPage);
            }

            checkVisibility(); // keep infinite scroll alive
          }

          button.removeAttribute("disabled");
          button.classList.remove("loading");

          if (currentPage === totalPages) {
            button.remove();
          }
        }

        isLoading = false;
      },
    });
  };
})();

window.updateShowingText = () => {
  let currentPage = parseInt($("[data-current-page]").val());
  const totalProducts = parseInt($("[data-total-products]").val());
  const perPage = $("[data-per-page]").data("per-page");

  if (totalProducts <= perPage) currentPage = 1;

  const text = totalProducts === 1 ? "product" : "products";
  const productsShowing = Math.min(currentPage * perPage, totalProducts);
  const showingText = `Showing ${productsShowing} of ${totalProducts} ${text}`;

  $(".showing-text").text(showingText);
};

// iOS-safe infinite scroll: IntersectionObserver + scroll fallback
const checkVisibility = (() => {
  let bound = false;

  const nearViewport = (el) => {
    if (!el || el.offsetParent === null) return false;
    const rect = el.getBoundingClientRect();
    return rect.top <= window.innerHeight + 600; // preload
  };

  const handler = () => {
    document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
      if (nearViewport(spinner)) loadItems(spinner);
    });
  };

  return () => {
    // Always do a direct visibility check (fixes iOS when IO doesn't fire)
    handler();

    // Bind fallback scroll listeners once
    if (!bound) {
      bound = true;
      window.addEventListener("scroll", handler, { passive: true });
      window.addEventListener("resize", handler);
    }

    // Also try IntersectionObserver when available
    if ("IntersectionObserver" in window) {
      document.querySelectorAll(".js-infinite-scroll").forEach((spinner) => {
        const io = new IntersectionObserver(
          (entries) => {
            entries.forEach((entry) => {
              if (entry.isIntersecting) {
                loadItems(spinner);
                io.unobserve(spinner);
              }
            });
          },
          { root: null, rootMargin: "0px 0px 800px 0px", threshold: 0 }
        );

        io.observe(spinner);
      });
    }
  };
})();

function loadMore() {
  document.querySelectorAll(".js-load-more").forEach((button) => {
    button.onclick = () => loadItems(button);
  });

  checkVisibility();
  window.updateShowingText();
}

(function () {
  loadMore();
})();

document.addEventListener("DOMContentLoaded", function () {
  loadMore();
  document.addEventListener("shopify:section:load", function () {
    loadMore();
  });
});
